import * as React from "react";
import { PupillaryDistanceDrawerLink } from "../../../components/PupillaryDistanceDrawerLink/steps/components/PupillaryDistanceLink/components/PupillaryDistanceDrawerLink/PupillaryDistanceDrawerLink.js";
import { PupillaryDistanceExternalLinkContainer } from "../../../components/PupillaryDistanceExternalLink/steps/components/PupillaryDistanceLink/components/PupillaryDistanceExternalLink/PupillaryDistanceExternalLinkContainer.js";
import { usePupillaryDistanceDrawerLink } from "../../../hooks/steps/components/PupillaryDistanceLink/hooks/use-pupillary-distance-drawer-link.js";
const PupillaryDistanceLink = ({ className }) => {
  const shouldUseDrawerLink = usePupillaryDistanceDrawerLink();
  if (shouldUseDrawerLink) {
    return /* @__PURE__ */ React.createElement(PupillaryDistanceDrawerLink, { className });
  }
  return /* @__PURE__ */ React.createElement(PupillaryDistanceExternalLinkContainer, { className });
};
export {
  PupillaryDistanceLink
};
//# sourceMappingURL=PupillaryDistanceLink.js.map
